import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";
import { Bar } from "react-chartjs-2";
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
Chart.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function MonthlyTradeVolumes() {
  const [monthlyTradeVolumes, setMonthlyTradeVolumes] = useState<any>(null);
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("TradesVolume", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setMonthlyTradeVolumes(response);
      });
  }, []);

 
  function formateAsPercent(num: any) {
    return new Intl.NumberFormat("default", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(num / 5.0);
  }
  function currencyFormat(num: any) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
 const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: 'Chart.js Bar Chart',
      },
    },
  };
  return (
    <div className="card w-100">
      <div className="card-header" style={{ paddingBottom: "0px" }}>
        <h5 className="card-title">Monthly Trade Volumes</h5>
      </div>
      <div className="card-body" style={{ paddingTop: "0px" }}>
        <div className="chart chart-xs">
          <div className="chartjs-size-monitor">
            <div className="chartjs-size-monitor-shrink styleScroll">
            <Bar options={options} data={monthlyTradeVolumes} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { MonthlyTradeVolumes };
